import Backbone from 'backbone';
import _ from 'lodash';

import { userHasRole } from '@/util/RoleUtils';

import GetOrderAdHocAttachments from '../services/GetOrderAdHocAttachments';
import GetOrderDocumentTypes from '../services/GetOrderDocumentTypes';
import OrderAttachmentsView from '../views/OrderAttachmentsView';
import GetCustomerOrderById from '../services/GetCustomerOrderById';
import GetOrderFundingAttachments from '../services/GetOrderFundingAttachments';
import GetOrderNonFundingAttachments from '../services/GetOrderNonFundingAttachments';
import GetCustomerOrderAttachmentDataByOrderID from '../services/GetCustomerOrderAttachmentDataByOrderID';

export default async function loadOrderAttachmentsView({ orderId, orderTypeId, isReadOnly, orderDetails }) {
  const [attachments, adHocAttachments, documentTypes, order, fundingAttachments, orderAttachmentData] = await Promise.all([
    GetOrderNonFundingAttachments(orderId),
    GetOrderAdHocAttachments(orderId),
    GetOrderDocumentTypes(orderTypeId, orderId),
    GetCustomerOrderById(orderId),
    GetOrderFundingAttachments(orderId),
    GetCustomerOrderAttachmentDataByOrderID(orderId)
  ]);

  const showFundingReasoning = _.some(documentTypes, { documentTypeDescription: 'Funding (Upload MIPR)' });
  const disableFundingReasoning = _.some(attachments, { documentTypeId: '4' }) || isReadOnly;

  const inProgress = order?.statusId > 4 && order?.statusId < 8;
  const orderSummaryExists = _.some(attachments, { documentTypeId: '44' });
  const canGenerate = (userHasRole('Admin') || userHasRole('EPC')) && inProgress;

  const isA3 = order.orderFormTypeId == 13;

  // Override a "no"/blank answer to having additional documents if additional documents are present
  if (attachments.length || adHocAttachments.length) {
    orderAttachmentData.additionalDocumentsRequired = '1';
  }

  orderDetails.orderTypeId = orderTypeId;
  return new OrderAttachmentsView({
    orderId,
    model: new Backbone.Model({
      documentTypes,
      attachments,
      adHocAttachments,
      fundingAttachments,
      orderSummaryAttachment: _.filter(attachments, { documentTypeId: '44' }),
      isReadOnly,
      orderDetails,
      showFundingReasoning,
      noFundingExplanation: order.noFundingExplanation,
      disableFundingReasoning,
      orderSummaryExists,
      canGenerate,
      isA3,
      orderAttachmentData
    })
  });
}
